import React, { useCallback, useState } from "react";
import UnsavedChangesConfirmModal from "./UnsavedChangesConfirmModal";

const DEFAULT_TITLE = "Discard unsaved changes?";
const DEFAULT_BODY = "Your data will be lost if you continue without saving.";

/**
 * Intercepts drawer close (X, Cancel, backdrop) when the form has unsaved edits.
 * Cancel keeps the drawer open; Continue discards and calls onClose.
 */
export function useGuardedDrawerClose(onClose, isDirty, { disabled = false } = {}) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const requestClose = useCallback(() => {
    if (disabled) return;
    if (isDirty) {
      setConfirmOpen(true);
      return;
    }
    onClose();
  }, [disabled, isDirty, onClose]);

  const cancelDiscard = useCallback(() => {
    setConfirmOpen(false);
  }, []);

  const confirmDiscard = useCallback(() => {
    setConfirmOpen(false);
    onClose();
  }, [onClose]);

  const confirmDialog = (
    <UnsavedChangesConfirmModal
      open={confirmOpen}
      onCancel={cancelDiscard}
      onContinue={confirmDiscard}
      title={DEFAULT_TITLE}
      body={DEFAULT_BODY}
      cancelLabel="Cancel"
      continueLabel="Continue"
    />
  );

  return { requestClose, confirmDialog };
}

export default useGuardedDrawerClose;
